/**
 * @generated SignedSource<<c0fa9d3cb4ea97afcec76e3372a774e3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type discountCodeDeleteButton_DiscountCodeFragment$data = {
  readonly id: string;
  readonly " $fragmentType": "discountCodeDeleteButton_DiscountCodeFragment";
};
export type discountCodeDeleteButton_DiscountCodeFragment$key = {
  readonly " $data"?: discountCodeDeleteButton_DiscountCodeFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"discountCodeDeleteButton_DiscountCodeFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "discountCodeDeleteButton_DiscountCodeFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "DiscountCode",
  "abstractKey": null
};

(node as any).hash = "4a96f1f2fabe66323883cc0dbcd3f7af";

export default node;
